import { Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { AutoSub, AutoSubOnDestroy, DeviceService } from '@motes-sdk/providers';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@AutoSubOnDestroy()
@Component({
    selector: 'autoplay-video',
    templateUrl: './autoplay-video.component.html',
    styleUrls: ['./autoplay-video.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AutoplayVideoComponent implements OnInit {

    @ViewChild('video', { static: true }) videoElement: ElementRef<HTMLVideoElement>;

    @Input() src: string = '';
    @Input() alt: string = 'Your browser is not able to show this video.';
    /** Set true to play video only once in viewport */
    @Input() playOnlyInView: boolean = false;

    constructor(private deviceService: DeviceService) { }

    ngOnInit(): void {
        // On touch devices the scrolling will be continuous, and so to detect play, set debounce time to 0
        let dbTime = this.deviceService.isTouchDevice() ? 0 : 200;

        if(typeof window === 'undefined' || !this.playOnlyInView) return;
        AutoSub(this).reg['scrollSub'] = fromEvent(window, 'scroll').pipe(debounceTime(dbTime)).subscribe(() => {
            this.detectVideoPlay();
        });
    }

    private detectVideoPlay() {
        let video = this.videoElement.nativeElement;
        let isVideoPlaying = !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
        if(isVideoPlaying) return;

        let videoRect = video.getBoundingClientRect();
        let videoFitsInViewport = videoRect.height < (window.innerHeight - 60);
        let isVideoInView = videoFitsInViewport ? (videoRect.top > 60 && videoRect.bottom < window.innerHeight) : (videoRect.top > 60);
        if(!isVideoInView) return;

        video.play();
    }
}
